export enum OrderReportType {
  Diagnostic = 'Diagnostic',
  Ancestry = 'Ancestry',
  Parentage = 'Parentage',
}
